import { useContext } from "react";
import { Divider, Grid } from "@mui/material";
import { formatPersianDate } from "../../../../utils/date";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import moment from "moment";

//import images and icons
import flightArrowIcon from "../../../../assets/icons/flight-line.svg";

function IntFlightInformation({ selectedFlight, cabin }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: undefined,
            weekday: "long",
        });
    };

    return (
        <Grid container item xs={12} rowGap={2}>
            {selectedFlight?.map(flight => {
                return (
                    <>
                        <Grid className="confirm__flight" container item xs={12} mt={2}>
                            <Grid component="img" src={flightArrowIcon} container item xs="auto" />
                            <Grid container item xs={4} direction="column" justifyContent="space-between">
                                <Grid container item xs="auto" direction="column">
                                    <span>{flight?.departure_time.split(":", 2).join(":")}</span>
                                    <span>
                                        {locale === "fa" ? formatDate(flight?.departure_date) : moment(flight?.departure_date).format("ddd D MMM")}
                                    </span>
                                </Grid>
                                <Grid container item xs="auto" direction="column">
                                    <span>{flight?.destination_time.split(":", 2).join(":")}</span>
                                    <span>
                                        {locale === "fa" ? formatDate(flight?.arrival_date) : moment(flight?.arrival_date).format("ddd D MMM")}
                                    </span>
                                </Grid>
                            </Grid>
                            <Grid container item xs={7} direction="column" justifyContent="space-between">
                                <span>
                                    {locale === "en" ? flight?.departure?.terminal?.name : flight?.departure?.terminal?.name}
                                    <br />
                                    {flight?.departure?.country?.persian} , {flight?.departure?.city?.persian}
                                </span>
                                <span>
                                    {locale === "en" ? flight?.destination?.terminal?.name : flight?.destination?.terminal?.name}
                                    <br />
                                    {flight?.destination?.country?.persian} , {flight?.destination?.city?.persian}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid className="confirm" container item xs={12}>
                            <Grid className="confirm__title" container item xs={12}>
                                {t("airline")} {locale === "en" ? flight?.airline?.english : flight?.airline?.persian}
                            </Grid>

                            <Divider width="100%" />

                            <Grid className="confirm__information" container item xs={12} rowGap={2}>
                                <Grid container item xs={3.8} direction="column">
                                    <span className="confirm__label">{t("flightNumber")}</span>
                                    <span className="confirm__value">{flight?.flight_number}</span>
                                </Grid>

                                <Grid container item xs={3.8} direction="column">
                                    <span className="confirm__label">{t("aircraft")}</span>
                                    <span className="confirm__value">{flight?.aircraft}</span>
                                </Grid>

                                <Grid container item xs={3.8} direction="column">
                                    <span className="confirm__label">{t("baggage")}</span>
                                    <span className="confirm__value">
                                        <bdi>{flight?.baggage}</bdi>
                                    </span>
                                </Grid>

                                <Grid container item xs={3.8} direction="column">
                                    <span className="confirm__label">{t("flightClass")}</span>
                                    <span className="confirm__value">{locale === "en" ? cabin?.english : cabin?.persian}</span>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                );
            })}
        </Grid>
    );
}

export default IntFlightInformation;
